import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import conversationResolutionSubjects from 'custom/dashboard/routes/dashboard/settings/conversationResolutionSubjects/conversationResolutionSubject.routes';
import clientSettings from 'custom/dashboard/routes/dashboard/settings/clientSettings/clientSettings.routes';
import profile from './profile/profile.routes';
// Zimobi
import forms from 'custom/dashboard/routes/dashboard/settings/forms/forms.routes';
import pipelines from 'custom/dashboard/routes/dashboard/settings/pipelines/pipelines.routes';
// Zimobi
import security from './security/security.routes';
import captain from './captain/captain.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...conversationResolutionSubjects.routes,
    ...clientSettings.routes,
    ...profile.routes,
    // Zimobi: the account's forms (Settings › Formulários).
    ...forms.routes,
    // Zimobi: the names each board gives a closed card (Settings › Funis).
    ...pipelines.routes,
    ...security.routes,
    ...captain.routes,
  ],
};
